import useReveal from "@/hooks/useReveal";

const ValuePropSection = () => {
  const [ref, isVisible] = useReveal();

  return (
    <section
      ref={ref}
      id="value-prop"
      data-testid="value-prop-section"
      className="py-20 md:py-32"
      style={{ backgroundColor: "#FAF9F6" }}
    >
      <div className={`max-w-3xl mx-auto px-6 md:px-12 text-center reveal-section ${isVisible ? "visible" : ""}`}>
        <p className="text-sm font-medium uppercase tracking-[0.2em] text-[#205B5A] mb-5">
          The platform
        </p>
        <h2
          data-testid="value-prop-heading"
          className="text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight leading-tight text-[#1A1B1A] mb-8"
          style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
        >
          One platform for running the clinic and completing notes faster
        </h2>
        <p
          data-testid="value-prop-body"
          className="text-base md:text-lg text-[#4A4B4A] leading-relaxed"
        >
          LumeroFlow brings together the operational side of clinic software with the speed of AI-assisted documentation. Instead of managing bookings in one tool and notes in another, clinics can keep everything connected in one workflow.
        </p>
      </div>
    </section>
  );
};

export default ValuePropSection;
